export default "__VITE_ASSET__AcroxW2d__"